import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Privacy() {
  const [text, setText] = useState("Loading...");

  useEffect(() => {
    fetch("/privacy.txt")
      .then((r) => r.text())
      .then(setText)
      .catch(() => setText("Failed to load Privacy Policy."));
  }, []);

  return (
    <div style={{ padding: "40px", color: "white", whiteSpace: "pre-wrap" }}>
      <h1>Privacy Policy</h1>
      <pre style={{ whiteSpace: "pre-wrap", fontSize: "1.1rem" }}>{text}</pre>
      <Link to="/" className="btn">Back</Link>
    </div>
  );
}
